module.exports = __webpack_public_path__ + "img/dial-min.b507940b.svg";